<template>
  <header>
    <nav class="bg-white px-4 py-2.5 dark:bg-gray-800 border-b border-gray-300">
      <div class="flex items-center justify-between max-w-screen-lg mx-auto">
        <div class="flex items-center justify-start">
          <a
            class="flex mr-6"
            href="/"
          > <img
            alt="Nevcap Logo"
            class="mr-3 ml-1.5 h-8 sm:h-8"
            src="../../../assets/images/nevcap-logo.svg"
          > </a>
          <form
            action="#"
            class="hidden md:block lg:pl-2"
            method="GET"
          >
            <label
              class="sr-only"
              for="topbar-search"
            >Search</label>
            <div class="relative md:w-64 lg:w-96">
              <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <svg
                  class="w-5 h-5 text-gray-500 dark:text-gray-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    clip-rule="evenodd"
                    d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                    fill-rule="evenodd"
                  />
                </svg>
              </div>
              <input
                id="topbar-search"
                class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full pl-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                name="search"
                placeholder="Search courses, users, modules..."
                type="text"
              >
            </div>
          </form>
        </div>
        <div
          v-if="user"
          class="flex items-center justify-between lg:order-2"
        >
          <DropdownMenu>
            <template #trigger>
              <div
                class="flex items-center justify-between p-1 mt-2 bg-black border rounded-full hover:bg-gray-900 min-w-48"
              >
                <div class="flex items-center">
                  <div class="flex items-center justify-center w-8 h-8 bg-white rounded-full hover:bg-yellow-300">
                    <span class="text-xs font-bold text-black">SN</span>
                  </div>
                  <div class="ml-2 mr-4 text-xs font-bold text-white">
                    {{ user.fullName }}
                  </div>
                </div>
                <div class="mr-4">
                  <svg
                    fill="none"
                    height="6"
                    viewBox="0 0 10 6"
                    width="10"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 1L5 5L9 1"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.33333"
                    />
                  </svg>
                </div>
              </div>
            </template>
            <template #content>
              <div class="px-5 py-3 -m-2 bg-black rounded-t-lg dark:bg-gray-700">
                <p class="text-sm text-gray-400 dark:text-gray-400">
                  Signed in as
                </p>
                <p class="text-sm font-medium text-white dark:text-gray-300">
                  {{ user ? user.email : '' }}
                </p>
              </div>
              <div class="py-2 mt-2 first:pt-0 last:pb-0">
                <router-link
                  class="flex items-center gap-x-3.5 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:ring-2 focus:ring-primary dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-gray-300 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
                  to="logout"
                >
                  Sign out
                </router-link>
              </div>
            </template>
          </DropdownMenu>
        </div>
      </div>
    </nav>
    <AdministratorNavbar />
  </header>
</template>

<script lang="ts">
import {defineComponent, inject} from 'vue';
import {useRouter} from 'vue-router';
import Navbar from '@/views/administrator/partials/Navbar.vue';
import Dropdown from '@/components/Dropdown.vue';
import {userKey} from '@/composables/useUser';
import axios, {AxiosError} from "axios";
import {ErrorResponse} from "@/types";

export default defineComponent({
  name: 'AdministratorHeader',
  components: {DropdownMenu: Dropdown, AdministratorNavbar: Navbar},
  setup() {
    const {user} = inject(userKey)!;
    const router = useRouter();

    const logout = async () => {
      try {
        await axios.post("/auth/logout");
        user.value = undefined;
        await router.push("/login");
      } catch (error: unknown) {
        const axiosError = error as AxiosError<ErrorResponse>;
        const message = axiosError.response?.data?.message || axiosError.message;
        console.error('Logout error:', message);
      }
    };

    return {user, router, logout};
  },
});
</script>
